module.exports = __webpack_public_path__ + "18bbbc81f9f814f98d7a7132adf4bf17.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/thumbnail/public/team/Leadership_Greg.jpg
// module id = 556
// module chunks = 0